<!-- LOGIN SECTION -->

<section class="container">
  <div class="row justify-content-center mt-3">
    <div class="col-sm-8 col-md-6 col-lg-5 signLog box-panel">
      <h2 class="text-center">Login Now</h2>
      <!-- LOGIN FORM START -->
      <form class="login-form form" [formGroup]="loginFrmGrp" (ngSubmit)="login()">
        <div class="form-group">
          <mat-form-field style="width: 100%">
            <input matInput placeholder="Username" formControlName="username" autocomplete="off">
            <mat-error>Required</mat-error>
          </mat-form-field>
          <a class="text-right login-forgot" (click)="goToForgotUsername()">
            Forgot Username ?
          </a>
          <mat-form-field style="width: 100%">
            <input matInput placeholder="Password" [type]="passwordHide ? 'password' : 'text'"
              formControlName="password" autocomplete="off">
            <mat-icon matSuffix (click)="togglePasswordHide()">{{passwordHide ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error>Required</mat-error>
          </mat-form-field>
          <div class="text-right login-forgot" (click)="goToForgotPassword()">Forgot Password ?
          </div>
        </div>
        <br><br>
        <!-- ALERT  WARNING START-->
        <div *ngIf="invalidLoginMessage" class="text-center mb-3 alert alert-danger" role="alert">
          <strong>{{invalidLoginMessage}}</strong>
        </div>
        <!--ALERT  WARNING END -->
        <div class="row justify-content-center">
          <div class="text-center">
            <input type="submit" class="btn btn-primary" value="Login" [disabled]="loginFrmGrp.invalid" />
            <br><br>
            <div class="register-text">Don't Have An Account ? <i class="fa fa-user-plus fa-xs-blue"></i><a
                class="login-signup" (click)="goToRegistration()">Sign Up</a> </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
